<template>
  <navbar />
  <section class="section">
    <div class="container">
      <h1 class="title">
        Select Spreadsheet
      </h1>

      <p class="subtitle">
        The spreadsheet must have the exact same format as our
        <a
          :href="
            `https://docs.google.com/spreadsheets/d/${starterTemplateSpreadsheetId}/edit`
          "
          target="_blank"
          rel="noopener noreferrer"
          >Balance Sheet Starter Template</a
        >.
        <br />
        If you don't have one,
        <router-link to="/spreadsheets/copy" class="has-text-weight-semibold">
          make a copy of our starter template
        </router-link>
        first.
      </p>

      <form class="mb-4" @submit.prevent="search">
        <div class="field">
          <div class="control">
            <input
              v-model="query"
              class="input"
              type="search"
              placeholder="Search Spreadsheet..."
            />
          </div>
        </div>
      </form>

      <div v-if="error" class="notification is-danger is-light">
        <p class="mb-2">{{ error }}</p>
        <a
          v-if="attemptedId"
          :href="
            `https://docs.google.com/spreadsheets/d/${attemptedId}/edit#gid=0`
          "
          class="button is-danger is-outlined"
          target="_blank"
          rel="noopener noreferrer"
          >Open Spreadsheet</a
        >
      </div>

      <template v-else-if="Array.isArray(files)">
        <ul v-if="files.length > 0">
          <li v-for="file in files" :key="file.id">
            <router-link :to="`/spreadsheets/${file.id}`">
              {{ file.name }}
            </router-link>
          </li>
        </ul>

        <div v-else class="notification">
          No results match your search query.
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash-es';
import Navbar from './Navbar.vue';

export default {
  components: {
    Navbar,
  },

  setup() {
    return {
      userEmail: window.gapi.auth2
        .getAuthInstance()
        .currentUser.get()
        .getBasicProfile()
        .getEmail(),
    };
  },

  data() {
    return {
      query: '',
      files: null,
      error: undefined,
      attemptedId: undefined,
    };
  },

  computed: {
    starterTemplateSpreadsheetId() {
      return process.env.VUE_APP_STARTER_TEMPLATE_SPREADSHEET_ID;
    },
  },

  watch: {
    query() {
      this.searchDebounced();
    },
  },

  created() {
    this.error = this.$route.query.error;
    this.attemptedId = this.$route.query.attempted_id;
    this.searchDebounced = debounce(this.search, 400);
  },

  methods: {
    async search() {
      this.error = null;

      if (this.query.trim().length == 0) {
        this.files = null;

        return;
      }

      try {
        const res = await window.gapi.client.drive.files.list({
          q: [
            `name contains "${this.query.trim()}"`,
            `"${this.userEmail}" in writers`,
            'mimeType = "application/vnd.google-apps.spreadsheet"',
            'trashed = false',
          ].join(' and '),
          fields: 'nextPageToken, files(id, name)',
          pageSize: 25,
        });

        this.files = res.result.files;
      } catch (error) {
        this.error = error.result.error.message;
      }
    },
  },
};
</script>
